import axios from "axios";
import Vue from "vue";
import { Loading } from "element-ui";
import { tansParams, blobValidate } from "@/utils/exseen";
import store from "@/store";
import { getToken } from "@/utils/auth";
import { saveAs } from "file-saver";

let downloadLoadingInstance;

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  // timeout: 15000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    console.log("service.request ===== ", config);
    if (store.getters.token) {
      // Authorization
      config.headers["Authorization"] = getToken();
    }
    if (config.timeout) {
      config.timeout = config.timeout;
    }
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    // 处理特殊接口返回数据
    // 例如：登录接口返回数据格式不一样，其他接口返回数据格式一致
    // 需要根据实际情况进行调整
    const freeApis = [
      "/api/captcha/get",
      "/api/captcha/check",
      "/api/captcha/verify",
      "/login/guide",
    ];
    if (freeApis.some((api) => response.config.url.includes(api))) {

      return response.data;
    }
    const res = response.data;
    console.log("response ===== ", response.data);
    // 二进制数据则直接返回
    if (
      response.request.responseType === "blob" ||
      response.request.responseType === "arraybuffer"
    ) {
      return response.data;
    }

    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 200 && res.code !== 202) {
      console.log("response ===== ", response.data);
      Vue.prototype.$message({
        dangerouslyUseHTMLString: true,
        message: res.message || "Error",
        type: "error",
      });
      if (res.code === 401) {
        store.dispatch("user/resetToken").then(() => {
          location.reload();
        });
      }
      return Promise.reject(new Error(res.message || "Error"));
    } else {
      return res.data || res.result;
    }
  },
  (error) => {
    console.log("err" + error); // for debug
    Vue.prototype.$message({
      message: error.message,
      type: "error",
    });
    return Promise.reject(error);
  }
);

// 通用下载方法
export function download(url, params, filename) {
  downloadLoadingInstance = Loading.service({
    text: "正在下载数据，请稍候",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
    customClass: "export-loading-fullscreen",
  });
  return service
    .post(url, params, {
      transformRequest: [
        (params) => {
          return tansParams(params);
        },
      ],
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      responseType: "blob",
    })
    .then(async (data) => {
      const isLogin = await blobValidate(data);
      if (isLogin) {
        const blob = new Blob([data]);
        saveAs(blob, filename);
      } else {
        const resText = await data.text();
        const rspObj = JSON.parse(resText);
        console.error("rspObj", rspObj);
        if (rspObj.code === 401) {
          downloadLoadingInstance.close();
          Vue.prototype.$message.error("token过期，请重新登录");
          store.dispatch("user/resetToken").then(() => {
            location.reload();
          });
          return;
        }
        const errMsg = rspObj.message || rspObj.msg;
        Vue.prototype.$message({ message: errMsg, type: "error" });
      }
      downloadLoadingInstance.close();
    })
    .catch((r) => {
      console.error(r);
      Vue.prototype.$message({
        message: "下载文件出现错误，请联系管理员！",
        type: "error",
      });
      downloadLoadingInstance.close();
    });
}
export default service;
